module.exports = __webpack_public_path__ + "img/2.4e05ce78.svg";